import { shallowEqual, useSelector } from 'react-redux';

export function useLanguageSetting() {
  const { currentEmployee } = useSelector(
    state => ({
      currentEmployee: state.userContext?.currentEmployee,
    }),
    shallowEqual
  );

  return currentEmployee?.language === 'French' ? 'fr' : 'en';
}
